import styled from 'styled-components';
import { Card, getSpacingToken, IconName, Link, Stack } from '@optimus-web/core';
import { loginMulticurrency } from '@mews-commander/assets';
import { DataTestId, TextKey } from '@mews-commander/enums';
import { LocalizedText } from '@mews/framework';
import { LocalizedTypography } from '@mews-commander/ui';
import { useLanguageCode } from '@mews-commander/core';
import { Image, ImageContentWrapper } from './styles';

const StyledImage = styled(Image)`
    /* picked from the BG image - so that white text is readable if image loads slowly */
    background-color: #1c192c;
    background-position: center;
`;

const StyledFeature = styled(Card)`
    background-color: rgba(28, 27, 27, 0.7);
    border-radius: 100px;
    padding: ${getSpacingToken('100')}px ${getSpacingToken('200')}px;
    backdrop-filter: blur(7px);
`;

const content = {
    background: loginMulticurrency,
    title: TextKey.SignInMarketingAltTitle,
    body: TextKey.SignInMarketingAltBody,
    features: [
        {
            key: 'SignInMarketingFeature1',
            text: TextKey.SignInMarketingAltFeature1,
        },
        {
            key: 'SignInMarketingFeature2',
            text: TextKey.SignInMarketingAltFeature2,
        },
        {
            key: 'SignInMarketingFeature3',
            text: TextKey.SignInMarketingAltFeature3,
        },
    ],
    linkLabel: <LocalizedText textKey={TextKey.SignInMarketingAltLinkLabel} />,
};

export const MarketingZone = () => {
    const currentLanguageCode = useLanguageCode().split('-')[0];
    const link = `https://www.mews.com/${currentLanguageCode}/campaigns/multicurrency`;

    return (
        <StyledImage src={content.background}>
            <ImageContentWrapper vertical>
                <Stack vertical spacing="100">
                    <LocalizedTypography textKey={content.title} textStyle="bodyLargeStrong" as="h2" />
                    <LocalizedTypography textKey={content.body} textStyle="bodyMedium" as="p" />
                </Stack>

                <Stack vertical spacing="200">
                    <Stack vertical spacing="50" itemAlignment="start">
                        {content.features.map((feature) => (
                            <StyledFeature key={feature.key} outline={false}>
                                <LocalizedTypography
                                    textKey={feature.text}
                                    textStyle="bodyMedium"
                                    variant="inverse"
                                    as="div"
                                />
                            </StyledFeature>
                        ))}
                    </Stack>

                    <Stack>
                        <Link
                            href={link}
                            target="_blank"
                            rel="noreferrer"
                            standalone={false}
                            underline={false}
                            icon={IconName.ExternalLink}
                            data-test-id={DataTestId.SignInMarketingLink}
                            variant="basic"
                        >
                            {content.linkLabel}
                        </Link>
                    </Stack>
                </Stack>
            </ImageContentWrapper>
        </StyledImage>
    );
};
